export default __webpack_public_path__ + "static/media/care_device_pin.e2df0f1c.svg";